import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import ReactTooltip from 'react-tooltip'
import Loader from '../components/Loader';

class SunwayPal extends Component {

    constructor(props) {
        super(props);
        const { location } = props;
        let cardId = ''
        let loading = false;
        let added = false;
        let alreadyAdded = false;
        let packageSelected

        this.state = {
            cardId,
            loading,
            added,
            alreadyAdded,
            packageSelected
        };
    }

    componentWillMount(){
    }

    componentDidMount() {        
        const { params: { gtrid }, location: {query: {value}} } = this.props;
    }

    handleAddPoints = () => {

        const { params: { gtrid }, location: {query: {value}} } = this.props;
        let { cardId } = this.state;
        this.setState({ loading: true });        

        return api('/api/sunwaypal/add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                card_id : cardId,
                gtr_id: gtrid,
                purchase_amount: value
            })
        }).then(result => {

            this.setState({ loading: false });        

            if(result){
                this.setState({ added: true });        
            } else {
                this.setState({
                    alreadyAdded: true
                 });        
            }
        })
    }

    handleCardIdChange = (event) => {
        this.setState({ cardId: event.target.value });
    }

    handleOnVoucherSelect = (voucherNumber) => {
        this.setState({ packageSelected: voucherNumber })
    }

    render() {
        const { error } = this.props
        const { cardId, loading, added, alreadyAdded, packageSelected } = this.state;
    
        return (
            <div className="sunwaypal-redemption-wrapper">
                <div >
                    <h3 className="sunway-pal-redemption-title">Giftr Voucher Redemption with SunwayPal Points</h3>
                    <br/>
                    <div className="row sunwaypal-row-wrapper">
                        <div className="col-sm-4">
                            <div onClick={() => this.handleOnVoucherSelect(1)} className="panel panel-default">
                                <div className={ packageSelected === 1 ? 'panel-heading sunway-pal-redeem-selected' : 'panel-heading'}>
                                    <h4 className="panel-title">Giftr RM10.00 Cash Voucher</h4>
                                </div>
                                <div className={ packageSelected === 1 ? 'panel-body sunway-pal-redeem-selected-body' : 'panel-body'}>
                                    Value: RM10.00<br/>
                                    Expiry: 1 month from date of redemption<br/>
                                    1 usage only<br/>
                                </div>
                                <div className={ packageSelected === 1 ? 'panel-footer sunway-pal-redeem-selected-button' : 'panel-footer sunway-pal-redeem-select-button'}>{packageSelected === 1 ? 'Selected': 'Select'}</div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div onClick={() => this.handleOnVoucherSelect(2)} className="panel panel-default">
                                <div className={ packageSelected === 2 ? 'panel-heading sunway-pal-redeem-selected' : 'panel-heading'}>
                                    <h4 className="panel-title">Giftr RM20.00 Cash Voucher</h4>
                                </div>
                                <div className={ packageSelected === 2 ? 'panel-body sunway-pal-redeem-selected-body' : 'panel-body'}>
                                    Value: RM20.00<br/>
                                    Expiry: 1 month from date of redemption<br/>
                                    1 usage only<br/>
                                </div>
                                <div className={ packageSelected === 2 ? 'panel-footer sunway-pal-redeem-selected-button' : 'panel-footer sunway-pal-redeem-select-button'}>{packageSelected === 2 ? 'Selected': 'Select'}</div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div onClick={() => this.handleOnVoucherSelect(3)} className="panel panel-default">
                                <div className={ packageSelected === 3 ? 'panel-heading sunway-pal-redeem-selected' : 'panel-heading'}>
                                    <h4 className="panel-title">Giftr RM50.00 Cash Voucher</h4>
                                </div>
                                <div className={ packageSelected === 3 ? 'panel-body sunway-pal-redeem-selected-body' : 'panel-body'}>
                                    Value: RM50.00<br/>
                                    Expiry: 1 month from date of redemption<br/>
                                    1 usage only<br/>
                                </div>
                                <div className={ packageSelected === 3 ? 'panel-footer sunway-pal-redeem-selected-button' : 'panel-footer sunway-pal-redeem-select-button'}>{packageSelected === 3 ? 'Selected': 'Select'}</div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div>
                                {
                                    error &&
                                    <Alert bsStyle="danger">
                                        <div>{error}</div>
                                    </Alert>
                                }
                                {/* <div>
                                    <div className="form-group">
                                            <input type="radio" name="type" value="sunway_pals_card"/> Sunway Pals Card No
                                            <input className="sunway-radio" type="radio" name="type" value="member_id"/> Sunway Pals Member ID 
                                    </div>
                                </div>                */}
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className="form-group">
                                            <select name="quantity" className="form-control">
                                                <option hidden selected disabled value="0">Select Quantity</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                            </select>
                                            <br/>
                                            <input data-tip="Sunway Pals Card Number or Member ID has 16-digit available on the back of your Sunway Pals card or mobile app" className="form-control" placeholder="Sunway Pals Card No / Member ID" type="text" maxLength="16" onChange={this.handleCardIdChange}/>
                                            <ReactTooltip class="sunway-tooltip" place="top" type="dark" effect="solid"/>
                                            <span className="sunway-signup">Not a Sunway Pals member yet? Sign up <a href="https://member.sunwaypals.com.my/sign_up" target="_blank">here</a>.</span>
                                        </div>
                                    </div>
                                    <div className="col-xs-12">
                                        <Button disabled={added} className="btn-postcode-checker" onClick={this.handleAddPoints} block>{added ? 'Redeemed' : 'Redeem'}</Button>
                                    </div>
                                </div>                      
                                {
                                    loading &&
                                    <Loader />
                                }
                                {
                                    alreadyAdded &&
                                    <p className="sunwaypal-error">The Points have been collected previously, please contact support@giftr.my for further assistance</p>
                                }
                                {
                                    added && 
                                    <p className="sunwaypal-success">Thanks for your submission. Sunway Pals Points will be awarded to your account within 14 working days. For queries, please write to support@giftr.my</p>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {
        
    };
})(SunwayPal);